exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RideList_name_3gbbd {\n  display: flex;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 0 8px;\n}\n\n.RideList_rideTime_1LlLN {\n  flex-grow: 1;\n}\n\n.RideList_rideStatus_1q8Mg {\n  font-size: 10px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.RideList_details_39E3t {\n  display: flex;\n  align-items: center;\n  height: 44px;\n  margin-top: 8px;\n  padding: 0 5px;\n}\n\n.RideList_addresses_3kt5W {\n  flex-grow: 1;\n  color: black;\n  font-size: 13px;\n  overflow: hidden;\n}\n\n.RideList_addresses_3kt5W > div {\n  height: 22px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.RideList_fare_OeA7X {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 12px;\n  margin-left: 8px;\n}\n\n.RideList_empty_1y84n {\n  margin: 0 24px;\n  font-size: 15px;\n}\n\n.RideList_divider_1Bops {\n  margin: 1px 25px 0;\n}\n\n.RideList_arrow_20ogP {\n  display: flex;\n  align-items: center;\n}\n", ""]);

// exports
exports.locals = {
	"name": "RideList_name_3gbbd",
	"rideTime": "RideList_rideTime_1LlLN",
	"rideStatus": "RideList_rideStatus_1q8Mg",
	"details": "RideList_details_39E3t",
	"addresses": "RideList_addresses_3kt5W",
	"fare": "RideList_fare_OeA7X",
	"empty": "RideList_empty_1y84n",
	"divider": "RideList_divider_1Bops",
	"arrow": "RideList_arrow_20ogP"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader!./src/ondemand/components/RideList/RideList.css
// module id = 1243
// module chunks = 2